import React, { useEffect, useState } from "react";
import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';
import Styles from './styles.module.scss';
import { useDispatch, useSelector } from "react-redux";
import {
    clearVerifyEmailError,
    resendVerifyCode,
    setSettingsVerifyModalStatus,
    verifyUserEmail
} from "../../store/cabinet/action";
import CodeInput from "../_UI/codeInput";
import {useTranslation} from "react-i18next";

const SettingsVerifyModal = () => {
    const dispatch = useDispatch();
    const { t } = useTranslation();

    const settingsVerifyModalStatus = useSelector(store => store.cabinet.settingsVerifyModalStatus);
    const verifyUserEmailStatusErr = useSelector(store => store.cabinet.verifyUserEmailStatusErr);
    const verifyUserEmailStatus = useSelector(store => store.cabinet.verifyUserEmailStatus);
    const userData = useSelector(store => store.cabinet.userData);

    const [timer, setTimer] = useState(0);
    const [isResendDisabled, setIsResendDisabled] = useState(false);
    const [code, setCode] = useState(Array(6).fill(''));

    const isCodeComplete = code.every(d => d !== '');

    const closeModal = () => {
        dispatch(setSettingsVerifyModalStatus(false));
    };

    const handleResendClick = () => {
        setIsResendDisabled(true);
        setTimer(60);
        dispatch(resendVerifyCode())
    };

    useEffect(() => {
        let interval = null;
        if (timer > 0) {
            interval = setInterval(() => {
                setTimer(prev => {
                    if (prev === 1) {
                        setIsResendDisabled(false);
                        clearInterval(interval);
                    }
                    return prev - 1;
                });
            }, 1000);
        }
        return () => clearInterval(interval);
    }, [timer]);

    useEffect(() => {
        if (!settingsVerifyModalStatus) {
            setCode(Array(6).fill(''));
        }
    }, [settingsVerifyModalStatus]);

    useEffect(() => {
        if (verifyUserEmailStatusErr?.code) {
            setCode(Array(6).fill(''));
        }
    }, [verifyUserEmailStatusErr]);

    useEffect(() => {
        if (verifyUserEmailStatus) {
            dispatch(setSettingsVerifyModalStatus(false));
            dispatch(clearVerifyEmailError());
            setCode(Array(6).fill(''));
            setTimer(0);
            setIsResendDisabled(false);
        }
    }, [verifyUserEmailStatus, dispatch]);

    useEffect(() => {
        if (settingsVerifyModalStatus) {
            dispatch(resendVerifyCode());
            setIsResendDisabled(true);
            setTimer(60);
        }
    }, [settingsVerifyModalStatus, dispatch]);

    return (
        <Popup
            open={settingsVerifyModalStatus}
            modal
            nested
            closeOnDocumentClick={false}
            closeOnEscape={false}
            onClose={closeModal}
        >
            <div className={Styles.modalContainer}>
                <div className={Styles.modalCloseBtn} onClick={closeModal}>
                    <div/>
                    <div/>
                </div>
                <div className={Styles.modalContentWrap}>
                    <div className={Styles.modalTitle}>{t('Верификаця почты')}</div>
                    <div className={Styles.modalNote}>
                        {t('Пожалуйста, введите 6-значный код, отправленный на адрес электронной почты')}: <span>{userData?.user?.email}</span>
                    </div>

                    <div className={Styles.modalCodeWrap}>
                        <CodeInput
                            length={6}
                            code={code}
                            onChangeCode={(newCode) => {
                                setCode(newCode);
                                if (verifyUserEmailStatusErr?.code) {
                                    dispatch(clearVerifyEmailError());
                                }
                            }}
                            hasError={!!verifyUserEmailStatusErr?.code}
                        />
                        <div className={Styles.codeErr}>{verifyUserEmailStatusErr?.code ? verifyUserEmailStatusErr?.code : ''}</div>
                    </div>

                    <div className={Styles.modalResendRow}>
                        <div className={Styles.modalResendRowName}>{t('Не получили код')}?</div>
                        <div className={Styles.modalResendRowValueWrap}>
                            <div className={Styles.modalResendRowValueTimer}>
                                {isResendDisabled ? `(${timer})` : ""}
                            </div>
                            <div
                                className={`${Styles.modalResendRowValue} ${isResendDisabled ? Styles.modalResendRowValueDsb : ""}`}
                                onClick={!isResendDisabled ? handleResendClick : undefined}
                            >
                                {t('Отправить повторно')}
                            </div>
                        </div>
                    </div>

                    <div
                        className={`${Styles.modalMainBtn} ${!isCodeComplete ? Styles.modalMainBtnDsb : ""}`}
                        onClick={() => {
                            if (isCodeComplete) {
                                const codeStr = code.join('');
                                dispatch(verifyUserEmail({code: codeStr}));
                            }
                        }}
                        style={{
                            cursor: isCodeComplete ? 'pointer' : 'not-allowed',
                            opacity: isCodeComplete ? 1 : 0.5
                        }}
                    >
                        {t('Верифицировать почту')}
                    </div>
                </div>
            </div>
        </Popup>
    );
};

export default SettingsVerifyModal;

